import { API_URL } from '@/App.settings';
import Dictionary from '@/types/Dictionary';
import MenuItem from '@/types/MenuItem';
import axios from 'axios';
import Vue from 'vue';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';


/** Store de gestion du menu contextuel sur les objets */
@Module({
	namespaced: true
})
class MenuStore extends VuexModule {
	/** Menu de création d'objets */
	private menuItems: MenuItem[] = [];
	/** Contraintes entre objets */
	private constraints: Dictionary<any> = {};

	@Mutation
	private setData({ menuItems, constraints }) {
		this.menuItems = menuItems;
		this.constraints = constraints;
	}

	/** Réinitialisation du store VueX */
    @Action({ rawError: true })
    public Reset() {
        this.context.commit('setData', { menuItems: [], constraints: {} });
    }

    @Action({ rawError: true })
    public async LoadData() {
        // Récupération menu de création des objets
		const args: Dictionary<any> = {};
		args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

		await axios.post(API_URL + "/object/InitContextMenuMain", args).then((response) => {
			if (response && response.data) {
				let result: Dictionary<any> = response.data;
				this.context.commit('setData', { menuItems: result["MenuItems"], constraints: result["Constraints"]});
			}
		});
    }

	public get GetMenuItems(): MenuItem[] {
        return this.menuItems;
    }

	public get GetConstraints(): Dictionary<any> {
        return this.constraints;
    }
}

export default MenuStore;